<template>
    <el-container class="ps-index">
        <el-header class="app-header editor-header">
            <app-title name="智能抠图" homeUrl='/template/public' @goHome="goHome" :isHomePage="false"></app-title>
        </el-header>
        <el-main>
            <iframe :src="psUrl" id="psIframe"></iframe>
        </el-main>
    </el-container>
</template>
<script>
    import appTitle from '@/views/layout/app-title';
    import {ps_url, material_type} from '@/const.js';
    import materialService from '@/request/service/material-service.js';
    import uploadService from '@/request/service/fileupload-service';
    import templateService from '@/request/service/template-service';
    import {ActionType} from "../../bean/UserAction";
    const PV_KEYS = [
        ActionType.cutout.time_to_export.actionKey,
        ActionType.cutout.time_to_save.actionKey,
        ActionType.cutout.time_to_matting.actionKey,
        ActionType.cutout.time_to_batch_export.actionKey,
        ActionType.cutout.time_to_batch_save.actionKey,
        ActionType.cutout.time_to_batch_matting.actionKey
    ];
    export default {
        name: 'editor-header',
        components: {appTitle},
        data() {
            return {
                psUrl: ps_url,
                port: null
            }
        },
        created() {
            this.onIframeLoad();
        },
        beforeDestroy(){
            window.removeEventListener('message', this.messageCallback);
        },
        methods: {
            goHome() {
                this.$emit('goHome');
            },
            goHome2() {
                window.location.href = window.location.origin;
            },
            saveMaterial(url) {
                return new Promise((resolve, reject) => {
                    templateService.getNosImgUrlByNetworkImg(url).then(({id, url, properties}) => {
                        let materialParams = {
                            projectId: this.$store.state.app.projectId,
                            type: material_type.element,
                            items: [
                                {
                                    name: '抠图素材-' + moment(new Date).format('YYYY-MM-DD hh:mm:ss'),
                                    url: url,
                                    storageId: id,
                                    widthHeight: properties,
                                }
                            ]
                        };
                        materialService.batchSaveMaterial(materialParams).then((data) => {
                            if(data.failCount > 0){
                                this.$message.error('保存失败');
                                reject('保存失败');
                            } else {
                                this.postToTemplateEditorPage(url, properties);
                                resolve('保存成功');
                            }
                        });
                    });
                });
            },
            postLoadData(userId, history){
                this.port.postMessage({
                    event: 'load',
                    data: {history: history, userId: userId}
                });
            },
            eventMethods() {
                return {
                    load: () => {
                        let userId = this.$store.state.app.loginUser.id;
                        materialService.getPSCache(userId).then((array) => {
                            if (array && array.length > 0 ) {
                                let jsonArray = [];
                                array.forEach(({json}) => {
                                    if(json){
                                        jsonArray.push(JSON.parse(json));
                                    }
                                });
                                this.postLoadData(userId, jsonArray);
                            } else {
                                this.postLoadData(userId, null);
                            }
                        }, () => {
                            this.postLoadData(userId, null);
                        });
                    },
                    uploadImage: ({imageData}) => {
                        uploadService.uploadFileByBase64(imageData).then(({url}) => {
                            this.port.postMessage({
                                event: 'uploadImage',
                                data: {
                                    url: url
                                }
                            });
                        });
                    },
                    saveAsset: async ({type, imageUrl}) => {
                        let imgArr = null;
                        if(Object.prototype.toString.call(imageUrl) === "[object Array]"){
                            imgArr = imageUrl;
                        } else {
                            imgArr = [imageUrl]
                        }
                        for(let url of imgArr){
                            await this.saveMaterial(url);
                        }
                        materialService.saveMaterialForPSCache(this.$store.state.app.projectId,type, null);
                        this.port.postMessage({
                            event: 'saveAsset',
                        });
                    },
                    postStep: (data) => {
                        materialService.saveMaterialForPSCache(this.$store.state.app.projectId,data.type, data);
                    },
                    reset: ({type}) => {
                        // 清空缓存记录
                        materialService.saveMaterialForPSCache(this.$store.state.app.projectId, type, null);
                        this.port.postMessage({
                            event: 'reset',
                            data:{}
                        });
                    },
                    trackPoint: ({categoryKey, actionKey, startTime, endTime}) => {
                        var obj = this.ActionType.cutout[actionKey];
                        if(obj){
                            if(PV_KEYS.indexOf(obj.actionKey) > -1){
                                let pid = this.$store.state.app.projectId;
                                this.saveUserActionForPage(pid, startTime, endTime, categoryKey, obj.actionKey);
                            } else {
                                this.saveUserAction(categoryKey, obj.actionKey);
                            }
                        }
                    }
                };
            },
            onIframeLoad() {
                window.addEventListener('message', this.messageCallback)
            },
            messageCallback(e){
                if (e.data && e.data.event) {
                    this.port = e.ports[0];
                    let func = this.eventMethods()[e.data.event];
                    func && func(e.data.data);
                }
            },
            postToTemplateEditorPage(url,properties){
                let originWin = parent.window.opener;
                originWin && originWin.postMessage({
                    psDataUrl: url,
                    properties: properties,
                }, location.origin)
            }
        }
    }
</script>
<style lang="scss">
    @import "ps";
</style>